import http from '@/service/http'
import findIndex from 'lodash/findIndex'

const save = async (context, obj) => {
  const { verb, contasBancarias } = obj
  const response = await http[verb]('/contasBancariasUsuarios', contasBancarias)

  if (response !== null) {
    if (response.data.data !== undefined) {
      contasBancarias.id = response.data.data.id
      update(context, { ...contasBancarias })
    }
    return Promise.resolve()
  }
}

const atualizar = async (context, obj) => {
  const response = await http.put('/contasBancariasUsuarios', obj)

  if (response !== null) {
    obj.id = response.data.data.id
    update(context, { ...obj })
    return Promise.resolve()
  }
}

const fetch = async ({ commit }, login) => {
  if (login) {
    const response = await http.get(`/contasBancariasUsuarios/contas/${login}`)
    if (response !== null) {
      const contasBancariasUsuarios = response.data
      commit('SET_LIST', contasBancariasUsuarios)
    }
  }
}

const fetchOne = async (context, id) => {
  const response = await http.get(`/contasBancariasUsuarios/${id}`)
  if (response !== null) {
    return Promise.resolve(response.data.data)
  }
}

const removeAllBancosUsuario = ({ commit }) => {
  commit('REMOVE_ALL_BANCOS_USUARIO')
}

// const fetch = async ({ commit }) => {
//   const response = await http.get('/contasBancariasUsuarios')
//   if (response !== null) {
//     const contasBancariasUsuarios = response.data
//     commit('SET_LIST', contasBancariasUsuarios)
//   }
// }
const fetchNull = async ({ commit }) => {
  commit('SET_LIST', [])
}

const update = ({ commit, state }, obj) => {
  const index = findIndex(state.list, { id: obj.id })
  const payload = { contasBancariasUsuarios: obj, index }
  commit('SET_ONE', payload)
}

const remove = ({ commit, state }, obj) => {
  return new Promise(async (resolve) => {
    const { id } = obj
    const response = await http.delete(`/contasBancariasUsuarios/${id}`)
    const message = response.data.data
    const index = findIndex(state.list, { id })

    if (index > -1) {
      commit('REMOVE_ONE', { index })
    }

    resolve(message)
  })
}

export default {
  fetch,
  fetchNull,
  removeAllBancosUsuario,
  fetchOne,
  save,
  update,
  remove,
  atualizar
}



// WEBPACK FOOTER //
// ./src/features/admin/contasBancariasUsuarios/store/actions.js